import React, { useEffect, useState } from "react";
import "../styles/HeroSection.css";

function HeroSection() {
  const [images, setImages] = useState([]);

  useEffect(() => {
    const imageContext = require.context(
      "../imgs/hero-section",
      false,
      /\.(png|jpe?g|svg)$/i
    );
    const seoOnlyImage = "cursos-enfermeria-quiropractica-nican";
    const lastImage = "graduacion-certificacion-laboral-ixtapaluca";
    const orderedImages = imageContext
      .keys()
      .filter((key) => {
        const cleanName = key
          .replace("./", "")
          .replace(/\.(png|jpe?g|svg)$/i, "");

        return cleanName !== seoOnlyImage;
      })
      .sort((a, b) => {
        const cleanA = a.replace("./", "").replace(/\.(png|jpe?g|svg)$/i, "");
        const cleanB = b.replace("./", "").replace(/\.(png|jpe?g|svg)$/i, "");

        if (cleanA === lastImage) return 1;
        if (cleanB === lastImage) return -1;

        return cleanA.localeCompare(cleanB);
      })
      .map((key) => {
        const cleanName = key
          .replace("./", "")
          .replace(/\.(png|jpe?g|svg)$/i, "");

        return {
          src: imageContext(key),
          alt: cleanName.replace(/-/g, " "),
        };
      });

    setImages(orderedImages);
  }, []);

  return (
    <section className="hero-section mt-5" id="home">
      <div className="hero-content">
        <div className="hero-copy">
          <h1 className="hero-title">
            Cursos y Certificaciones Profesionales en Ixtapaluca Estado de Mexico
          </h1>
          <p>
            Aprende Enfermeria, Quiropractica, Fisioterapia y Certificaciones
            SEP.
          </p>
          <a className="hero-cta" href="#certificaciones">
            Consulta nuestros cursos disponibles
          </a>
        </div>

        <div className="hero-carousel-panel" aria-label="Galeria Fundacion Nican">
          <div
            id="heroCarousel"
            className="carousel slide hero-carousel"
            data-bs-ride="carousel"
          >
            <div className="carousel-indicators hero-carousel-indicators">
              {images.map((_, index) => (
                <button
                  key={index}
                  type="button"
                  data-bs-target="#heroCarousel"
                  data-bs-slide-to={index}
                  className={index === 0 ? "active" : ""}
                  aria-current={index === 0 ? "true" : undefined}
                  aria-label={`Ir a imagen ${index + 1}`}
                ></button>
              ))}
            </div>

            <div className="carousel-inner">
              {images.map((image, index) => (
                <div
                  key={image.src}
                  className={`carousel-item ${index === 0 ? "active" : ""}`}
                >
                  <img
                    src={image.src}
                    alt={`${image.alt} en Fundacion Nican Ixtapaluca`}
                    className="carousel-image"
                  />
                </div>
              ))}
            </div>

            <button
              className="carousel-control-prev fixed-controls"
              type="button"
              data-bs-target="#heroCarousel"
              data-bs-slide="prev"
              aria-label="Imagen anterior"
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Anterior</span>
            </button>
            <button
              className="carousel-control-next fixed-controls"
              type="button"
              data-bs-target="#heroCarousel"
              data-bs-slide="next"
              aria-label="Imagen siguiente"
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Siguiente</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
